{
  "button-bar-for-selected-service": {
    "text": {
      "and-x-more": "và {{nr}} nữa",
      "duration": "Thời lượng",
      "select-service-hint": "Vui lòng chọn ít nhất một dịch vụ và thời gian mong muốn để tiếp tục"
    }
  }
}
